import { Datatype } from '../../../../datatype/Datatype.ts';
import { createConditionOperator } from '../../IConditionOperator.ts';

/**
 * Versione di "not defined" per i campi array.
 */
export const ConditionOperatorEmptyItemType = createConditionOperator({
  code: 'emptyItem',
  label: 'è vuoto',
  description: 'È vuoto',
  args: [],
  allowsField: field => field.type === Datatype.Array,
  compare(value: any) {
    if (!value) return true;
    return Array.isArray(value) && value.length === 0;
  },
});
